import { FC, SVGProps } from 'react'
import BeddingIcon from '../icons/bedding_awards_icon.inline.svg'

export const PRODUCT_CATALOG_ID_TO_ICON_MAP: Record<number, FC<SVGProps<SVGElement>>> = {
  1626: BeddingIcon,
}
